const breakpoints = {
  xs: '(min-width: 0)',
  sm: '(min-width: 600px)',
  md: '(min-width: 960px)',
  lg: '(min-width: 1280px)',
  xl: '(min-width: 1920px)'
};

const breakpoint = key => {
  return `
    ${breakpoints[key]}
  `;
};

export default breakpoint;
export { breakpoints };
